const __all = {
  "__active": {
    "colors": {
      "brand": {
        "primary": "#6C00F6",
        "primaryLight1": "#EBDDFF",
        "primaryLight2": "#B07CFF",
        "primaryDark1": "#4A00A8",
        "primaryDark2": "#2D0066",
        "secondary": "#A1F919",
        "secondaryLight1": "#EEFFC9",
        "secondaryLight2": "#EEFFC9",
        "secondaryDark1": "#6EA90F",
        "secondaryDark2": "#6EA90F",
        "tertiary": "#00B8FF",
        "tertiaryLight1": "#EBDDFF",
        "tertiaryLight2": "#EBDDFF",
        "tertiaryDark1": "#6C00F6",
        "tertiaryDark2": "#4A00A8"
      },
      "neutral": {
        "white": "#FFFFFF",
        "lightest": "#EEEEEE",
        "lighter": "#CCCCCC",
        "light": "#AAAAAA",
        "base": "#666666",
        "dark": "#444444",
        "darker": "#222222",
        "darkest": "#000000"
      },
      "text": {
        "title": "#222222",
        "primary": "#222222",
        "secondary": "#444444",
        "muted": "#666666",
        "disabled": "#AAAAAA"
      },
      "background": {
        "main": "#FFFFFF",
        "secondary": "#EEEEEE",
        "branded": "#6C00F6"
      },
      "border": {
        "default": "#EEEEEE",
        "dark": "rgba(0, 0, 0, 0.15)"
      },
      "button": {
        "primary": "#6C00F6",
        "primaryHover": "#4A00A8",
        "secondary": "#FFFFFF"
      },
      "link": "#6C00F6",
      "status": {
        "success": "#34C759",
        "error": "#FF3B30",
        "warning": "#FF9500",
        "info": "#007AFF"
      },
      "opacity": {
        "white5": "rgba(255, 255, 255, 0.05)",
        "white10": "rgba(255, 255, 255, 0.10)",
        "white15": "rgba(255, 255, 255, 0.15)",
        "white20": "rgba(255, 255, 255, 0.20)",
        "white30": "rgba(255, 255, 255, 0.30)",
        "white40": "rgba(255, 255, 255, 0.40)",
        "white50": "rgba(255, 255, 255, 0.50)",
        "white60": "rgba(255, 255, 255, 0.60)",
        "black5": "rgba(0, 0, 0, 0.05)",
        "black10": "rgba(0, 0, 0, 0.10)",
        "black15": "rgba(0, 0, 0, 0.15)",
        "black20": "rgba(0, 0, 0, 0.20)",
        "black30": "rgba(0, 0, 0, 0.30)",
        "black40": "rgba(0, 0, 0, 0.40)",
        "black50": "rgba(0, 0, 0, 0.50)",
        "black60": "rgba(0, 0, 0, 0.60)"
      }
    },
    "fontFamily": {
      "heading": "'Satoshi', sans-serif",
      "body": "'Inter', sans-serif"
    }
  },
  "aldar": {
    "colors": {
      "brand": {
        "primary": "#003087",
        "primaryLight1": "#E6EDF7",
        "primaryLight2": "#5791FB",
        "primaryDark1": "#002066",
        "primaryDark2": "#001647",
        "secondary": "#C69C6D",
        "secondaryLight1": "#FAF8F6",
        "secondaryLight2": "#FAF8F6",
        "secondaryDark1": "#A4705B",
        "secondaryDark2": "#A4705B",
        "tertiary": "#5791FB",
        "tertiaryLight1": "#DEE4EF",
        "tertiaryLight2": "#E6EDF7",
        "tertiaryDark1": "#003087",
        "tertiaryDark2": "#002066"
      },
      "neutral": {
        "white": "#FFFFFF",
        "lightest": "#EEEEEE",
        "lighter": "#CCCCCC",
        "light": "#AAAAAA",
        "base": "#666666",
        "dark": "#444444",
        "darker": "#222222",
        "darkest": "#000000"
      },
      "text": {
        "title": "#222222",
        "primary": "#222222",
        "secondary": "#444444",
        "muted": "#666666",
        "disabled": "#AAAAAA"
      },
      "background": {
        "main": "#FFFFFF",
        "secondary": "#EEEEEE",
        "branded": "#003087"
      },
      "border": {
        "default": "#EEEEEE",
        "dark": "rgba(0, 0, 0, 0.15)"
      },
      "button": {
        "primary": "#003087",
        "primaryHover": "#002066",
        "secondary": "#FFFFFF"
      },
      "link": "#003087",
      "status": {
        "success": "#34C759",
        "error": "#FF3B30",
        "warning": "#FF9500",
        "info": "#007AFF"
      },
      "opacity": {
        "white5": "rgba(255, 255, 255, 0.05)",
        "white10": "rgba(255, 255, 255, 0.10)",
        "white15": "rgba(255, 255, 255, 0.15)",
        "white20": "rgba(255, 255, 255, 0.20)",
        "white30": "rgba(255, 255, 255, 0.30)",
        "white40": "rgba(255, 255, 255, 0.40)",
        "white50": "rgba(255, 255, 255, 0.50)",
        "white60": "rgba(255, 255, 255, 0.60)",
        "black5": "rgba(0, 0, 0, 0.05)",
        "black10": "rgba(0, 0, 0, 0.10)",
        "black15": "rgba(0, 0, 0, 0.15)",
        "black20": "rgba(0, 0, 0, 0.20)",
        "black30": "rgba(0, 0, 0, 0.30)",
        "black40": "rgba(0, 0, 0, 0.40)",
        "black50": "rgba(0, 0, 0, 0.50)",
        "black60": "rgba(0, 0, 0, 0.60)"
      }
    },
    "fontFamily": {
      "heading": "'Montserrat', sans-serif",
      "body": "'Montserrat', sans-serif"
    }
  },
  "indigo": {
    "colors": {
      "brand": {
        "primary": "#000099",
        "primaryLight1": "#afe4ff",
        "primaryLight2": "#4d4dd6",
        "primaryDark1": "#000070",
        "primaryDark2": "#000047",
        "secondary": "#7fd287",
        "secondaryLight1": "#f1fbf5",
        "secondaryLight2": "#f1fbf5",
        "secondaryDark1": "#209326",
        "secondaryDark2": "#209326",
        "tertiary": "#00aee5",
        "tertiaryLight1": "#d1efff",
        "tertiaryLight2": "#afe4ff",
        "tertiaryDark1": "#000099",
        "tertiaryDark2": "#000070"
      },
      "neutral": {
        "white": "#FFFFFF",
        "lightest": "#EEEEEE",
        "lighter": "#CCCCCC",
        "light": "#AAAAAA",
        "base": "#666666",
        "dark": "#444444",
        "darker": "#222222",
        "darkest": "#000000"
      },
      "text": {
        "title": "#222222",
        "primary": "#25304b",
        "secondary": "#4b5772",
        "muted": "#7a85a0",
        "disabled": "#9ba4b8"
      },
      "background": {
        "main": "#FFFFFF",
        "secondary": "#EEEEEE",
        "branded": "#000099"
      },
      "border": {
        "default": "#EEEEEE",
        "dark": "rgba(0, 0, 0, 0.15)"
      },
      "button": {
        "primary": "#000099",
        "primaryHover": "#000070",
        "secondary": "#FFFFFF"
      },
      "link": "#000099",
      "status": {
        "success": "#218946",
        "error": "#c3272e",
        "warning": "#a97d0e",
        "info": "#348dc4"
      },
      "opacity": {
        "white5": "rgba(255, 255, 255, 0.05)",
        "white10": "rgba(255, 255, 255, 0.10)",
        "white15": "rgba(255, 255, 255, 0.15)",
        "white20": "rgba(255, 255, 255, 0.20)",
        "white30": "rgba(255, 255, 255, 0.30)",
        "white40": "rgba(255, 255, 255, 0.40)",
        "white50": "rgba(255, 255, 255, 0.50)",
        "white60": "rgba(255, 255, 255, 0.60)",
        "black5": "rgba(0, 0, 0, 0.05)",
        "black10": "rgba(0, 0, 0, 0.10)",
        "black15": "rgba(0, 0, 0, 0.15)",
        "black20": "rgba(0, 0, 0, 0.20)",
        "black30": "rgba(0, 0, 0, 0.30)",
        "black40": "rgba(0, 0, 0, 0.40)",
        "black50": "rgba(0, 0, 0, 0.50)",
        "black60": "rgba(0, 0, 0, 0.60)"
      }
    },
    "fontFamily": {
      "heading": "'Bauhaus Std', 'Bauhaus Pro', 'Poppins', sans-serif",
      "body": "'Poppins', sans-serif"
    }
  },
  "navi": {
    "colors": {
      "brand": {
        "primary": "#E5102E",
        "primaryLight1": "#FBE5EA",
        "primaryLight2": "#F0667E",
        "primaryDark1": "#CB002E",
        "primaryDark2": "#6E0019",
        "secondary": "#000000",
        "secondaryLight1": "#F5F5F5",
        "secondaryLight2": "#F5F5F5",
        "secondaryDark1": "#000000",
        "secondaryDark2": "#000000",
        "tertiary": "#E5102E",
        "tertiaryLight1": "#F7D6DD",
        "tertiaryLight2": "#FBE5EA",
        "tertiaryDark1": "#E5102E",
        "tertiaryDark2": "#CB002E"
      },
      "neutral": {
        "white": "#FFFFFF",
        "lightest": "#EEEEEE",
        "lighter": "#CCCCCC",
        "light": "#AAAAAA",
        "base": "#666666",
        "dark": "#444444",
        "darker": "#222222",
        "darkest": "#000000"
      },
      "text": {
        "title": "#222222",
        "primary": "#222222",
        "secondary": "#444444",
        "muted": "#666666",
        "disabled": "#AAAAAA"
      },
      "background": {
        "main": "#FFFFFF",
        "secondary": "#EEEEEE",
        "branded": "#E5102E"
      },
      "border": {
        "default": "#EEEEEE",
        "dark": "rgba(0, 0, 0, 0.15)"
      },
      "button": {
        "primary": "#CB002E",
        "primaryHover": "#CB002E",
        "secondary": "#FFFFFF"
      },
      "link": "#CB002E",
      "status": {
        "success": "#34C759",
        "error": "#FF3B30",
        "warning": "#FF9500",
        "info": "#007AFF"
      },
      "opacity": {
        "white5": "rgba(255, 255, 255, 0.05)",
        "white10": "rgba(255, 255, 255, 0.10)",
        "white15": "rgba(255, 255, 255, 0.15)",
        "white20": "rgba(255, 255, 255, 0.20)",
        "white30": "rgba(255, 255, 255, 0.30)",
        "white40": "rgba(255, 255, 255, 0.40)",
        "white50": "rgba(255, 255, 255, 0.50)",
        "white60": "rgba(255, 255, 255, 0.60)",
        "black5": "rgba(0, 0, 0, 0.05)",
        "black10": "rgba(0, 0, 0, 0.10)",
        "black15": "rgba(0, 0, 0, 0.15)",
        "black20": "rgba(0, 0, 0, 0.20)",
        "black30": "rgba(0, 0, 0, 0.30)",
        "black40": "rgba(0, 0, 0, 0.40)",
        "black50": "rgba(0, 0, 0, 0.50)",
        "black60": "rgba(0, 0, 0, 0.60)"
      }
    },
    "fontFamily": {
      "heading": "'Satoshi', sans-serif",
      "body": "'Inter', sans-serif"
    }
  },
  "snoonu": {
    "colors": {
      "brand": {
        "primary": "#D90217",
        "primaryLight1": "#FFE5E7",
        "primaryLight2": "#F2737D",
        "primaryDark1": "#A80112",
        "primaryDark2": "#8C0C00",
        "secondary": "#FFD84D",
        "secondaryLight1": "#FFF5D9",
        "secondaryLight2": "#FFF5D9",
        "secondaryDark1": "#B38F00",
        "secondaryDark2": "#B38F00",
        "tertiary": "#FF4D5E",
        "tertiaryLight1": "#FFD6DA",
        "tertiaryLight2": "#FFE5E7",
        "tertiaryDark1": "#D90217",
        "tertiaryDark2": "#A80112"
      },
      "neutral": {
        "white": "#FFFFFF",
        "lightest": "#EEEEEE",
        "lighter": "#CCCCCC",
        "light": "#AAAAAA",
        "base": "#666666",
        "dark": "#444444",
        "darker": "#222222",
        "darkest": "#000000"
      },
      "text": {
        "title": "#222222",
        "primary": "#222222",
        "secondary": "#444444",
        "muted": "#666666",
        "disabled": "#AAAAAA"
      },
      "background": {
        "main": "#FFFFFF",
        "secondary": "#EEEEEE",
        "branded": "#D90217"
      },
      "border": {
        "default": "#EEEEEE",
        "dark": "rgba(0, 0, 0, 0.15)"
      },
      "button": {
        "primary": "#D90217",
        "primaryHover": "#A80112",
        "secondary": "#FFFFFF"
      },
      "link": "#D90217",
      "status": {
        "success": "#34C759",
        "error": "#FF3B30",
        "warning": "#FF9500",
        "info": "#007AFF"
      },
      "opacity": {
        "white5": "rgba(255, 255, 255, 0.05)",
        "white10": "rgba(255, 255, 255, 0.10)",
        "white15": "rgba(255, 255, 255, 0.15)",
        "white20": "rgba(255, 255, 255, 0.20)",
        "white30": "rgba(255, 255, 255, 0.30)",
        "white40": "rgba(255, 255, 255, 0.40)",
        "white50": "rgba(255, 255, 255, 0.50)",
        "white60": "rgba(255, 255, 255, 0.60)",
        "black5": "rgba(0, 0, 0, 0.05)",
        "black10": "rgba(0, 0, 0, 0.10)",
        "black15": "rgba(0, 0, 0, 0.15)",
        "black20": "rgba(0, 0, 0, 0.20)",
        "black30": "rgba(0, 0, 0, 0.30)",
        "black40": "rgba(0, 0, 0, 0.40)",
        "black50": "rgba(0, 0, 0, 0.50)",
        "black60": "rgba(0, 0, 0, 0.60)"
      }
    },
    "fontFamily": {
      "heading": "'Playfair Display', serif",
      "body": "'Merriweather', serif"
    }
  }
} as const;

type __Shape = (typeof __all)["__active"];
const __tenant = typeof document !== "undefined" ? document.documentElement.getAttribute("data-zv-tenant") || "" : "";
const __hit = __tenant !== "__active" ? (__all as unknown as Record<string, __Shape | undefined>)[__tenant] : undefined;
const __pick: __Shape = __hit ?? __all.__active;

export const colors = __pick.colors;

export const fontFamily = __pick.fontFamily;
